import service from "./service";

/** GET /account — the personal profile and the workspace profile together. */
const getAccount = async () => {
  return service.get("/account").then((response) => {
    return response;
  });
};

// GET /account/usage - what the org has consumed against its plan limits.
const getUsage = async () => {
  return service.get("/account/usage").then((response) => {
    return response;
  });
};

/**
 * PATCH /account — partial, so only edited fields go over the wire.
 * @param {object} payload any subset of the account fields
 */
const updateAccount = async (payload) => {
  return service.patch("/account", payload).then((response) => {
    return response;
  });
};

const accountService = {
  getAccount,
  getUsage,
  updateAccount,
};

export default accountService;
